import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  apiClient,
  apiClientHooks,
  HTTP_UNAUTHORIZED,
} from "../../api/apiClient";
import store from "../../store";
import { clearState } from "../../localStorage";
import { ROLES } from "../accounts/accountConstants";

/*
 @TODO refactor session token handling
 The token is already handled by session reducer in store state. So the
 explicit local storage handling seems to be redundant.
 */

apiClientHooks.onUnauthorized.push(() => {
  store.dispatch(deleteSessionToken());
  clearState();
});

export const hasAuthorizedRole = (roles) =>
  roles.some((role) => role === ROLES.ADMIN || role === ROLES.PROPERTY_MANAGER);

export const requestSessionTokenThunk = createAsyncThunk(
  "session/requestSessionToken",
  async ({ emailAddress, password }, { rejectWithValue }) => {
    try {
      const response = await apiClient().post("sessions", {
        emailAddress,
        password,
      });
      const { data } = response;

      // redirect if user role is not occupant
      // NOTE: Redirect only necessary when a the requirement says you
      //       can not login as a "Verwalter"
      //

      if (hasAuthorizedRole(data.user.roles)) {
        // window.location = process.env.REACT_APP_MANAGEMENT_URL;
        return rejectWithValue({ code: "unauthorizedRole" });
      }

      return data.token;
    } catch (err) {
      if (err?.response?.status === HTTP_UNAUTHORIZED) {
        return rejectWithValue({ messageId: "ErrorMessage.unauthorized" });
      }
      throw err;
    }
  },
);

export const completeInvitationThunk = createAsyncThunk(
  "session/completeInvitation",
  async ({ token, password }, { dispatch, rejectWithValue }) => {
    try {
      const response = await apiClient().post("/accounts/_acceptInvitation", {
        token,
        password,
      });
      const { data } = response;
      if (data.sessionToken && data.finished) {
        return data.sessionToken;
      } else {
        return rejectWithValue({
          messageId: "ErrorMessage.invitationIncomplete",
        });
      }
    } catch (err) {
      console.error("Error while completing invitation.", err);
      return rejectWithValue(err.response.data);
    }
  },
);

const sessionSlice = createSlice({
  name: "session",
  initialState: "",
  reducers: {
    deleteSessionToken: () => "",
  },
  extraReducers: (builder) => {
    builder
      .addCase(requestSessionTokenThunk.fulfilled, (state, action) => {
        return action.payload;
      })
      .addCase(completeInvitationThunk.fulfilled, (state, action) => {
        return action.payload;
      });
  },
});

export const { deleteSessionToken } = sessionSlice.actions;

export const reducer = sessionSlice.reducer;
